import React, { useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { useAuthStatus } from "./AuthStatusContext";

const AuthRoute: React.FC = () => {
  const { authStatus, groupStatus } = useAuthStatus();
  const auth = useAuth();
  const location = useLocation();
  const [isValidToken, setIsValidToken] = useState<boolean | null>(null);

  // Validate token expiration explicitly
  useEffect(() => {
    const validateToken = () => {
      try {
        const idToken = localStorage.getItem("id_token");
        const accessToken = localStorage.getItem("access_token");

        if (!idToken || !accessToken) {
          setIsValidToken(false);
          return false;
        }
        // tokens exist – assume valid; backend will enforce expiry
        setIsValidToken(true);
        return true;
      } catch (err) {
        console.error("Error validating tokens", err);
        setIsValidToken(false);
        return false;
      }
    };
    validateToken();
  }, [location.pathname]);

  // If unauthenticated redirect to wrapper page, unless we are already on the Cognito callback route
  if (authStatus === "unauth" && !auth.isLoading) {
    if (location.pathname.startsWith("/oauth2")) {
      // We are on the callback page waiting for tokens to process
      return <div>Completing sign in...</div>;
    }
    else {
      // Store the current path so we can redirect back after authentication
      localStorage.setItem('redirectAfterAuth', location.pathname + location.search);
      return <Navigate to="/signin" replace />;
    }
  }

  // Loading states
  if (auth.isLoading || isValidToken === null || authStatus === "loading" || groupStatus === "loading") {
    return <div>Verifying authentication...</div>;
  }

  if (authStatus === "unauth") {
    // Redirect to wrapper page instead of direct Cognito login
    return <Navigate to="/signin" replace />;
  }

  if (groupStatus === "unauthorized") {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default AuthRoute;
